import { PlayerService } from "./PlayerService";

type CheckCodeResponse = {
    correct: boolean;
};

export class KeypadService {
    private _playerService: PlayerService = new PlayerService();
    public async checkCode(code: string, room: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}keypad/check-code/${code}/${room}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }
        );
        const data: CheckCodeResponse = await response.json() as CheckCodeResponse;
        return data.correct;
    }
}
